module.exports = __webpack_public_path__ + "img/xin-chakan.d07784a1.png";